var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.show)?_c('v-tooltip',{attrs:{"bottom":!_vm.top,"top":_vm.top},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("activator",null,{"on":on,"attrs":attrs})]}}],null,true)},[(!_vm.customTooltip)?_c('span',[_vm._v(_vm._s(_vm.tooltip))]):_c('span',[_vm._t("tooltip")],2)]):_vm._t("activator")],2)}
var staticRenderFns = []

export { render, staticRenderFns }